<script>
export default {
  name: "InstagramEmbed",
  props: {
    html: {
      type: String
    },
    className: {
      type: String
    }
  },
  mounted() {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    } else {
      this.injectScript();
    }
  },
  methods: {
    /**
     * inject instagram embed script
     */
    injectScript() {
      const protocolToUse = "https:";
      const s = document.createElement("script");
      s.async = s.defer = true;
      s.src = `${protocolToUse}//platform.instagram.com/en_US/embeds.js`;
      s.id = "instagram-embed-script";
      const body = document.body;
      if (body) {
        if (!document.getElementById("instagram-embed-script")) {
          body.appendChild(s);
        }
      }
    }
  },
  render() {
    return <div class={this.className} domPropsInnerHTML={this.html}></div>;
  }
};
</script>
